"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_INITIAL_VALUES = exports.DEFAULT_STORE_VALUES = exports.DEFAULT_BASIC_ITEMS = exports.MAX_GENKYU_KEKKIN_NISSU = exports.PAYSLIP_EXPENSES = exports.PAYSLIP_JIYURAN_COUNT = exports.DEFAULT_TOAST_DURATION = exports.UNIQUE_VALIDATION = exports.DATE_LIMIT = exports.TIME_OFFSET = exports.CONSUMPTION_TAX = exports.ITEM_HOST_NAME = void 0;
var graphql_1 = require("../__generated__/graphql");
// item
exports.ITEM_HOST_NAME = "場内指名";
// 消費税
exports.CONSUMPTION_TAX = 0.1;
// 1日の区切りは6時間後ろにずらす
exports.TIME_OFFSET = 6;
// 伝票などをWebアプリから参照できる期限の日数
exports.DATE_LIMIT = 40;
// ユニーク制約重複時にAPIから返るエラーを判別する文字列
exports.UNIQUE_VALIDATION = "Unique constraint failed on the fields: (`account`)";
/** ポップアップの表示持続時間(ミリ秒) */
exports.DEFAULT_TOAST_DURATION = 6000;
// 給料一覧の自由欄の数
exports.PAYSLIP_JIYURAN_COUNT = 10;
// 給料一覧に反映させる経費項目名
exports.PAYSLIP_EXPENSES = ["日払い", "立替金"];
// 減給欠勤日数の固定値
exports.MAX_GENKYU_KEKKIN_NISSU = 100;
// デフォルト基本料金
exports.DEFAULT_BASIC_ITEMS = {
    tableCharge: {
        itemName: "テーブルチャージ",
        defaultPrice: 500,
    },
    set: {
        itemName: "セット",
        defaultPrice: 3000,
    },
};
// 店舗の各種デフォルト設定値
// (DB上の店舗及び伝票履歴テーブルのデフォルト値と合わせて更新)
exports.DEFAULT_STORE_VALUES = {
    serviceFee: 37,
    isOrderItemLocked: false,
    orderItemLockTime: "2345",
    staffReservationFee: 4000,
    defaultTableChargeCount: 16,
    kaikinNgAmount: 4000,
    naikinUriage: true,
    naikinKaikinSho: false,
    genkyuKekkinNissu: 3,
    firstServe: false,
    amountRoundingMethod: graphql_1.RoundingMethod.ROUND,
};
// 初回コース関連デフォルト設定値
exports.DEFAULT_INITIAL_VALUES = {
    price: 0,
    count: 1,
};
//# sourceMappingURL=index.js.map